module.exports = __webpack_public_path__ + "static/media/BarcelonaActiva2.49b9041d.png";